import { render, staticRenderFns } from "./keywordrulebased.vue?vue&type=template&id=509d3b4e&"
import script from "./keywordrulebased.vue?vue&type=script&lang=js&"
export * from "./keywordrulebased.vue?vue&type=script&lang=js&"
import style0 from "./keywordrulebased.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports